// dropdownOptions.ts

import axiosInstance from '../utils/axiosConfig';

export interface DropdownOption {
  value: string;
  label: string;
  mondayId?: string;
}

let cachedActivityOptions: DropdownOption[] = [];
let activityCacheExpiry = 0;

let cachedIMCOptions: DropdownOption[] = [];
let imcCacheExpiry = 0;

const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

/**
 * Fetch Monday Activities (unchanged)
 */
export const getDropdownOptions = async (): Promise<DropdownOption[]> => {
  const now = Date.now();
  
  if (cachedActivityOptions.length > 0 && now < activityCacheExpiry) {
    return cachedActivityOptions;
  }

  try {
    const response = await axiosInstance.get('/api/monday/activities');
    cachedActivityOptions = response.data;
    activityCacheExpiry = now + CACHE_DURATION;
    return cachedActivityOptions;
  } catch (error) {
    console.error('Error fetching activities:', error);
    return cachedActivityOptions; // Return cached if available
  }
};

/**
 * NEW: Fetch IMC Codes from Monday API
 * Replaces the hardcoded imcCodes.ts constants
 */
export const getIMCCodeOptions = async (): Promise<DropdownOption[]> => {
  const now = Date.now();
  
  // Return cached if still valid
  if (cachedIMCOptions.length > 0 && now < imcCacheExpiry) {
    return cachedIMCOptions;
  }

  try {
    const response = await axiosInstance.get('/api/monday/imc');
    
    // Response format from backend: 
    // [{ value: "label text", label: "label text", mondayId: "123" }]
    cachedIMCOptions = response.data;
    imcCacheExpiry = now + CACHE_DURATION;
    
    console.log(`✅ Fetched ${cachedIMCOptions.length} IMC codes from Monday API`);
    return cachedIMCOptions;
  } catch (error) {
    console.error('❌ Error fetching IMC codes from Monday:', error);
    
    // Return cached if available, otherwise empty array
    if (cachedIMCOptions.length > 0) {
      console.warn('⚠️ Using cached IMC codes due to fetch error');
      return cachedIMCOptions;
    }
    
    return [];
  }
};

/**
 * Clear all caches (useful for manual refresh)
 */
export const clearDropdownCache = () => {
  cachedActivityOptions = [];
  activityCacheExpiry = 0;
  cachedIMCOptions = [];
  imcCacheExpiry = 0;
  console.log('🗑️ Dropdown caches cleared');
};